import { render, staticRenderFns } from "./HomeworkUploadedList.vue?vue&type=template&id=2d6e0010&scoped=true&"
import script from "./HomeworkUploadedList.vue?vue&type=script&lang=js&"
export * from "./HomeworkUploadedList.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkUploadedList.vue?vue&type=style&index=0&id=2d6e0010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e0010",
  null
  
)

export default component.exports